import React from 'react';
import { IM100RichTextModule } from '~/lib/data-contract';
import { M100 } from './m100-rich-text';

export const M100RichTextBlock = ({ text, id }: IM100RichTextModule) => {
    return <M100 id={id} text={text} />;
};
